{
  "selected_tickets": "Selected tickets",
  "diagnostic_file": "Diagnostic",
  "transparency": {
    "generate_file": "Generate a report",
    "modal": {
      "description": "The generation of a real report will impact your data, this action is irreversible. Do you want to generate a test or real report ?",
      "test": "Test",
      "real": "Real"
    },
    "report_type": {
      "diagnostic": "Diagnostic",
      "test_report": "Test report",
      "real_report": "Real report"
    },
    "period": {
      "to": "to"
    }
  }
}
